import { storeWrapper } from '../storeWrapper'
import { getCompanyCodeFromUrl, getDatabaseSuffixFromUrl } from '@repo/utils/urlParsing'
import { getAppInsightsInstance } from '@repo/app-assets/ApplicationInsights'
import { useAuthenticationStore } from '@repo/store/useAuthenticationStore'
import { ospreyAPI } from '@repo/api/ospreyAPI'

let version = '0.0.0'

const getDomainDetails = (set, get) => {
  const host = window?.location?.host || 'localhost'
  const isLocal = host.includes('localhost')
  let companyCode = ''
  let subdomain = ''
  let databaseSuffix = ''
  let baseURL = ''

  const isOutlook = Boolean(window.Office)

  if (isOutlook) {
    if (get) {
      companyCode = get().companyCode
      subdomain = get().subdomain
      databaseSuffix = get().databaseSuffix
      baseURL = get().baseURL
    }
  } else {
    const urlCompanyCodeDetails = getCompanyCodeFromUrl(isLocal, host)
    companyCode = urlCompanyCodeDetails.companyCode
    subdomain = urlCompanyCodeDetails.subdomain

    const urlDatabaseSuffixDetails = getDatabaseSuffixFromUrl(isLocal)
    databaseSuffix = urlDatabaseSuffixDetails.databaseSuffix

    baseURL = `https://${subdomain}.ospreyapproach.com/${databaseSuffix}`

    // update app insights user context
    const appInsights = getAppInsightsInstance()
    let userId = 'Unknown'
    try {
      userId = useAuthenticationStore.getState().userId
    } catch (err) {
      // swallow error - store not initialised yet
    }

    if (appInsights) appInsights.setAuthenticatedUserContext(userId, `${companyCode}/${databaseSuffix}`)

    if (set) set({ companyCode, subdomain, databaseSuffix, isLocal, baseURL })
  }

  return { companyCode, subdomain, databaseSuffix, isLocal, baseURL }
}

const { companyCode, subdomain, databaseSuffix, isLocal, baseURL } = getDomainDetails()
const sidebarBreakpoint = 1280

const isOutlookAddin = window.Office ? true : false

const initialState = {
  environmentName: import.meta.env.VITE_SPA_OSPREY_ENV || import.meta.env.VITE_OUTLOOK_ADDIN_ENVIRONMENT || 'dev',
  useMicrosoftEmail:
    (isOutlookAddin ||
      import.meta.env.VITE_SPA_OSPREY_USE_MICROSOFT_EMAIL === 'true' ||
      import.meta.env.VITE_SPA_OSPREY_USE_MICROSOFT_EMAIL === true ||
      false),
  companyCanUseMicrosoftEmail: null, // important that this is null, as opposed to false so we can tell when it has been set
  subdomain,
  companyCode,
  databaseSuffix,
  baseURL,
  isLocal,
  version,
  isPageScrollable: true,
  sidebarBreakpoint,
  sidebarMode: window.innerWidth >= sidebarBreakpoint ? 'expanded' : 'closed',
  pageTitleBlockIsVisible: true,
  ospreySite: '',
  isOutlookAddin
}

export const useGlobalSettingsStore = storeWrapper('useGlobalSettingsStore', (set, get) => ({
  ...initialState,
  setVersion: (v) => set({ version: v }),
  setPageScrollable: (isScrollable) => set({ isPageScrollable: isScrollable }),
  setSidebarMode: (sidebarMode) => set({ sidebarMode }),
  setPageTitleBlockIsVisible: (pageTitleBlockIsVisible) => set({ pageTitleBlockIsVisible }),
  getDomainDetails: () => getDomainDetails(set, get),
  fetchCanCompanyUseMicrosoftEmail: async () => {
    const res = await ospreyAPI({
      service: 'lookups',
      endpoint: 'OspreyConfiguration/GetEnableGraphApiEmailSubscriptions',
      method: 'GET'
    })

    const companyCanUseMicrosoftEmail = res === true || res === 'true'
    set({ companyCanUseMicrosoftEmail })

    // set this as a global value that Osprey 1 can read
    window.UseGraphApiEmailSubscriptions = companyCanUseMicrosoftEmail

    return companyCanUseMicrosoftEmail
  },
  reset: () => {
    // don't reset sidebarmode
    const { sidebarMode, ospreySite } = get()
    set({ ...initialState, sidebarMode, ospreySite })
    getDomainDetails(set, get)
  }
}))
